(function () {
    'use strict';

    var module = angular.module('uwAgenda.settings.agendasettings');
    module.controller('AgendaSettingsSharedAgendaTypeController', ['sharedAgendaDto', AgendaSettingsSharedAgendaTypeControllerFn]);

    /* controller for shared agenda type */
    function AgendaSettingsSharedAgendaTypeControllerFn(sharedAgendaDto) {
        var vm = this;

        // shared agenda dto
        vm.sharedAgendaDto = null;
        // title for breadcrumb
        vm.title = '';

        activate();

        /* activation work */
        function activate() {
            vm.sharedAgendaDto = sharedAgendaDto;
            vm.title = sharedAgendaDto.isReleasedView ? 'shared_with' : 'other_agendas';
        } // activate
    }
})();
